import React from "react";

const TotalCard = ({ viewMode, totalTime }) => (
  <div className="flex flex-wrap w-[200px]">
    {viewMode == "location" ? (
      <>
        <hr className="w-full mt-12" />
        <div className="max-w-xs w-full border-b border-gray-200 h-[277px] bg-white  text-sm  px-6 py-3 mb-2">
          <h2 className="text-lg font-semibold text-gray-800 mb-4">
            Fortnightly total
          </h2>
          <div className="space-y-2">
            <div className="flex justify-between text-gray-700">
              <span>Sch. hrs</span>
              <span className="font-medium">{totalTime}h</span>
            </div>
            <div className="flex justify-between text-gray-700">
              <span>Sch. wages</span>
              <span className="font-medium">€0</span>
            </div>
            <div className="flex justify-between text-gray-700">
              <span>Forecast sales</span>
              <span className="font-medium">€0</span>
            </div>
            <div className="flex justify-between text-gray-700">
              <span>Sales per hr</span>
              <span className="font-medium">€0</span>
            </div>
            <div className="flex justify-between text-gray-700">
              <span>Labor %</span>
              <span className="font-medium">0.00%</span>
            </div>
          </div>
        </div>
      </>
    ) : (
      <>
        <div className="max-w-xs w-full  bg-white  text-sm  px-6 pt-3">
          <h2 className="text-lg font-semibold text-gray-800 mb-4">
            Fortnightly total
          </h2>
          <div className="space-y-2">
            <div className="flex justify-between text-gray-700">
              <span>Sch. hrs</span>
              <span className="font-medium">{totalTime}h</span>
            </div>
            <div className="flex justify-between text-gray-700">
              <span>Sch. wages</span>
              <span className="font-medium">€0</span>
            </div>
            <div className="flex justify-between text-gray-700">
              <span>Forecast sales</span>
              <span className="font-medium">€0</span>
            </div>
            <div className="flex justify-between text-gray-700">
              <span>Sales per hr</span>
              <span className="font-medium">€0</span>
            </div>
            <div className="flex justify-between text-gray-700">
              <span>Labor %</span>
              <span className="font-medium">0.00%</span>
            </div>
          </div>
        </div>
      </>
    )}
  </div>
);

export default TotalCard;
